// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"SchoolLogo_imageContainer__3EAEa"};